import { useState } from 'react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
  Autoplay,
  Navigation,
  A11y,
  Lazy,
  EffectFade,
  Controller
} from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';
import 'swiper/css/a11y';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';
import { replaceTripshepherdWithSeeSight } from '../../utils/trip-sheppered-text';
SwiperCore.use([Autoplay, Navigation, Lazy, A11y, EffectFade, Controller]);
interface IProps {
  guidesData: any;
}
const GuidesMobile = ({ guidesData }: IProps) => {
  const [controlledSwiper, setControlledSwiper] = useState<any>({});

  if (!guidesData) {
    return <div>Loading...</div>;
  }
  return (
    <div
      id="guides_wrapper"
      className="border-[1px] border-[#C5C5C5] shadow-guidesBox relative mt-4"
    >
      <div
        id="top-guides-wrapper"
        className="w-[95%] xsm:max-h-[70%] md:max-h-[100%] h-[70%] mx-auto"
      >
        <Swiper
          id="top-slider"
          slidesPerView={1}
          spaceBetween={1}
          onSwiper={setControlledSwiper}
          loop={true}
          loopedSlides={guidesData?.length}
          lazy={{ loadPrevNext: true, checkInView: true }}
          a11y={{ itemRoleDescriptionMessage: 'Showing our Guide information' }}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          className="h-[100%]"
          speed={10000}
        >
          {guidesData &&
            guidesData.length > 0 &&
            guidesData?.map((guide: any, index: number) => (
              <SwiperSlide key={guide?.id} className="pt-6 pb-10">
                <div
                  id="guide-bio"
                  className="max-h-[270px] xsm:max-h-[270px] sm:max-h-[318px]  overflow-y-auto"
                >
                  <div className="relative w-[150px] h-[140px] float-left mr-3 ">
                    <Image
                      src={guide?.professional[0]?.url}
                      width={400}
                      height={400}
                      alt={guide?.professional[0]?.alt}
                      className=" absolute top-0  border-[7px] h-[140px]  border-[#FFFFFF] rounded-[5px] shadow-smallguideimageBox"
                    />
                  </div>
                  <div className="text-start pr-3">
                    <h3 className=" text-base  font-[600] text-[#333333] uppercase">
                      {guide?.firstName}
                    </h3>
                    <p
                      style={{
                        whiteSpace: 'break-spaces'
                      }}
                      className="text-[#333333] text-start sm:text-justify overflow-auto  text-sm font-[400] pr-3 inline tracking-[-0.01rem]"
                    >
                      {`${replaceTripshepherdWithSeeSight(guide?.biography)}`}
                    </p>
                  </div>

                  {/* </div> */}
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      <div
        id="bottom-guides-wrapper"
        className="max-w-[220px] max-h-[80px] xsm:max-w-[240px] xsm:max-h-[90px] sm:max-w-[293px] sm:max-h-[125px] w-[100%] h-[100%] px-5 rounded-[10px] shadow-moreguideBox absolute xxsm:top-[90%] xsm:top-[92%] sm:top-[88%] md:top-[88%] lg:top-[92%] xxsm:left-[24%] xsm:left-[28%] xsm:rig-[28%] sm:left-[40%] md:left-[42%] lg:left-[57%] xl:left-[64%] bg-[#FFFFFF] z-20"
      >
        <div className="xsm:pt-2 sm:pt-2">
          <div className="relative">
            <h4 className="xsm:text-[14px] sm:text-[16px] text-[#000000] font-[400]">
              More Guides
            </h4>
            <Swiper
              id="bottom-slider"
              slidesPerView={5}
              spaceBetween={1}
              loop={true}
              loopedSlides={guidesData?.length}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              navigation={{
                nextEl: '.nextButton'
              }}
              lazy={{ loadPrevNext: true, checkInView: true }}
              a11y={{ itemRoleDescriptionMessage: 'Showing all our Guides' }}
              controller={{ control: controlledSwiper }}
              grabCursor
              slideToClickedSlide
              className="rounded-[5px]"
            >
              {guidesData &&
                guidesData.length > 0 &&
                guidesData?.map((guide: any, index: number) => (
                  <SwiperSlide key={guide?.id}>
                    <div
                      id="image-wrapper"
                      className="w-[45px] h-[43px] xsm:w-[57px] xsm:h-[50px] sm:w-[65px] sm:h-[65px] relative overflow-hidden rounded-[5px]"
                    >
                      <Image
                        src={guide?.professional[0]?.url}
                        width={200}
                        height={200}
                        alt={guide?.professional[0]?.alt}
                        className="object-cover rounded-[5px] w-[100%] h-[100%]"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              <div className="w-[45px] h-[43px] xsm:w-[45px] xsm:h-[50px] sm:w-[55px] sm:h-[65px] bg-[#000000cc] absolute top-0 right-0 z-50 rounded-[5px] flex justify-center items-center">
                <Image
                  src={
                    'https://res.cloudinary.com/see-sight-tours/image/upload/v1687441211/Remaining%20images/Landing/Frame_107_1_wcdlli.svg'
                  }
                  width={25}
                  height={25}
                  alt="guides"
                  className="nextButton"
                />
              </div>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuidesMobile;
